<template>
  <v-container>
    <v-layout row>
      <!-- need to search for concord posts and user generated, add button to choose just concord or user generated -->

      <v-card
        justify="center"
        class="text-center elevation-5 primary"
        id="scroll-target"
        style="margin: auto; margin-bottom: 10px; width: 95%;padding: 20px;border-radius: 10px; "
      >
        <v-text-field
          label="Search"
          color="white"
          class="rounded"
          solo
          autofocus
          append-icon="search"
          v-model="search"
          @input="change()"
        ></v-text-field>
        <v-layout
          class="elevation-5 "
          row
          style="border-radius: 10px;  padding: 20px; background: white !important; margin-bottom: 20px; display: grid;"
        >
          <v-flex>
            <v-autocomplete
              v-model="chosenTags"
              :items="possibleTags.topics"
              dense
              chips
              small-chips
              label="Tags"
              multiple
              style="margin-bottom: 8px;"
            >
              <template slot="selection" slot-scope="data" pa-5>
                <v-chip
                  text-color="white"
                  :selected="data.selected"
                  close
                  class="chip--select-multi titles"
                  @input="data.parent.selectItem(data.item)"
                >
                  {{ data.item }}
                </v-chip>
              </template>

              <template slot="item" slot-scope="data">
                <v-list-tile-content v-text="data.item"></v-list-tile-content>
              </template>
            </v-autocomplete>
          </v-flex>
          <v-flex>
            <v-autocomplete
              v-model="location"
              :items="possibleTags.location"
              dense
              chips
              small-chips
              label="Location"
              style="margin-bottom: 8px;"
              clearable
            >
              <template slot="selection" slot-scope="data" pa-5>
                <v-chip
                  class="titles elevation-4"
                  text-color="white"
                  :selected="data.selected"
                  @input="data.parent.selectItem(data.item)"
                >
                  {{ data.item }}
                </v-chip>
              </template>

              <template slot="item" slot-scope="data">
                <v-list-tile-content v-text="data.item"></v-list-tile-content>
              </template>
            </v-autocomplete>
          </v-flex>
          <v-flex
            style="margin-bottom:10px; display: flex; flex-direction: row;"
          >
            <div
              style="background:white; display: inline; padding: 5px; border-radius: 15px; width: -webkit-fill-available;"
            >
              <v-menu
                v-model="datemenu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="searchDate"
                    prepend-icon="event"
                    readonly
                    label="Start Date"
                    v-on="on"
                    :disabled="!News"
                    clearable
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="searchDate"
                  @input="datemenu = false"
                ></v-date-picker>
              </v-menu>
            </div>
            <div
              style="background:white; display: inline; padding: 5px; border-radius: 15px; width: -webkit-fill-available;"
            >
              <v-menu
                v-model="dateEndmenu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="searchEndDate"
                    prepend-icon="event"
                    readonly
                    label="End Date"
                    v-on="on"
                    clearable
                    :disabled="!News"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="searchEndDate"
                  @input="dateEndmenu = false"
                ></v-date-picker>
              </v-menu>
            </div>
          </v-flex>
          <v-flex style="display:flex;">
            <v-switch
              v-model="News"
              color="success"
              label="Posts"
              @change="changeInput($event, 'news')"
              style="display: inline-block; margin-left: 10px; "
            ></v-switch>
            <v-switch
              v-model="profile"
              color="success"
              label="Profiles"
              @change="changeInput($event, 'profile'), pullFromDatabase"
              style="display: inline-block; margin-left: 10px; "
            ></v-switch>
          </v-flex>
        </v-layout>

        <v-list
          class="elevation-0 hidden-sm-and-down"
          v-if="filteredResources.length > 0"
          two-line
          style=" border-radius: 10px; padding-bottom: 1px; background-color:#fff0; display: grid; grid-template-columns: repeat(auto-fit,minmax(34%, 1fr)); column-gap: 15px;"
        >
          <template
            v-for="resource in filteredResources"
            pa-1
            style="  padding-left: 10px"
          >
            <div
              :key="resource.id + 'mobile'"
              @click="openPost(resource)"
              class="elevation-2 search"
              style="border-radius: 10px;  padding: 20px; margin-bottom: 10px; display: flex; align-items: center; "
            >
              <v-card flat pa-1 class="search" style="width:100%;">
                <p
                  class="text-wrap"
                  style="font-weight: bold;font-size: 16px;margin-bottom: 0px;padding-left: 10px;overflow-wrap: break-word;padding-right: 10px; white-space: normal; word-wrap: break-word; width: auto; text-transform: capitalize;"
                  pa-1
                >
                  {{ resource.title }}
                </p>
                <p
                  v-if="resource.username != null"
                  class="text-wrap"
                  style="font-size: 14px; margin-bottom: 0px; padding-left: 10px; overflow-wrap: break-word; padding-right: 10px; display: inline; white-space: normal; word-wrap: break-word; width: auto; text-transform: capitalize;"
                  pa-1
                >
                  @{{ resource.username }}
                </p>

                <v-list style="background: #edefee;">
                  <div
                    v-show="resource.tags.length > 0"
                    style="    display: contents;"
                  >
                    <template v-for="(tag, i) in resource.tags">
                      <v-chip
                        v-if="i < 2"
                        :key="tag + 'desktop' + resource.id"
                        @click="pushTag(tag)"
                        class="ma-2 titles elevation-4"
                        style="height:25px;"
                        text-color="white"
                        >{{ tag }}</v-chip
                      >
                      <v-chip
                        v-else-if="i == 2"
                        :key="tag + 'desktop' + resource.id"
                        class="ma-2 titles elevation-4"
                        style="height:25px;"
                        @click="pushTag(tag)"
                        text-color="white"
                        >+&nbsp;{{ resource.tags.length - 2 }}</v-chip
                      >
                    </template>
                    <v-chip
                      v-if="
                        resource.state &&
                          ((resource.type == 'profile' &&
                            resource.stateSwitch) ||
                            resource.type == 'news')
                      "
                      :key="resource.state + 'desktop' + resource.id"
                      @click="pushTag(resource.state)"
                      class="ma-2 secondary elevation-4 titles--text"
                      style="height:25px;"
                      text-color="white"
                      >{{ resource.state }}</v-chip
                    >
                  </div>
                  <v-btn
                    color="secondary"
                    text-color="secondary"
                    v-if="resource.count != null"
                    class="upvote elevation-4"
                    flat
                    lighten-2
                    style="border-radius: 20px;  height:25px; min-width:5px; color:white;padding: 10px;    font-weight: 600; background: #014A3C !important;"
                  >
                    <v-icon dark style="font-size:20px; ">star</v-icon>
                    &nbsp; {{ resource.count }}
                  </v-btn>
                  <v-chip
                    color="secondary"
                    v-if="resource.supporters != null"
                    class="ma-2 upvote elevation-4"
                    style="background:#014A3C !important;  height:25px; padding: 5px; font-weight:600;"
                    text-color="secondary"
                    ><v-icon dark style="font-size:20px; ">person</v-icon>
                    &nbsp; {{ resource.supporters }}</v-chip
                  >
                </v-list>
                <!-- <p
                  pa-2
                  style="display: inline; font-weight: bold;padding-top: 2px;padding-left: 10px;margin-bottom: 0px; text-transform: uppercase;"
                  class="text-wrap"
                >
                  {{ resource.type }}
                </p> -->
                <p
                  pa-2
                  v-if="resource.time != null"
                  style="display: inline; font-weight: bold;padding-top: 2px;margin-bottom: 0px; text-transform: uppercase;"
                  class="text-wrap"
                >
                  {{ resource.time }}
                </p>
                <p
                  pa-2
                  v-if="resource.bio != null"
                  style="display: inline; font-weight: bold;padding-top: 2px;margin-bottom: 0px;"
                  class="text-wrap"
                >
                  {{ resource.bio.substring(0,100).trim() }}<strong v-if="resource.bio.length > 99">...</strong>
                </p>
              </v-card>
            </div>
          </template>
        </v-list>
        <v-list
          class="elevation-0 hidden-md-and-up"
          v-if="filteredResources.length > 0"
          two-line
          style=" border-radius: 10px; padding-bottom: 1px; background-color:#fff0;"
        >
          <template
            v-for="resource in filteredResources"
            pa-1
            style="  padding-left: 10px"
          >
            <div
              :key="resource.id + 'desktop'"
              @click="openPost(resource)"
              class="elevation-2 search"
              style="border-radius: 10px;  padding: 20px; margin-bottom: 10px; /*display: inline-block*/ "
            >
              <v-card flat pa-1 class="search" style="width:100%;">
                <p
                  class="text-wrap"
                  style="font-weight: bold;font-size: 16px;margin-bottom: 0px;padding-left: 10px;overflow-wrap: break-word;padding-right: 10px; white-space: normal; word-wrap: break-word; width: auto; text-transform: capitalize;"
                  pa-1
                >
                  {{ resource.title }}
                </p>
                <p
                  v-if="resource.username != null"
                  class="text-wrap"
                  style="font-size: 14px; margin-bottom: 0px; padding-left: 10px; overflow-wrap: break-word; padding-right: 10px; display: inline; white-space: normal; word-wrap: break-word; width: auto; text-transform: capitalize;"
                  pa-1
                >
                  @{{ resource.username }}
                </p>

                <v-list style="background: #edefee;">
                  <div
                    v-show="resource.tags.length > 0"
                    style="    display: contents;"
                  >
                    <template v-for="(tag, i) in resource.tags">
                      <v-chip
                        v-if="i < 2"
                        :key="tag + 'desktop' + resource.id"
                        @click="pushTag(tag)"
                        class="ma-2 titles elevation-4"
                        style="height:25px;"
                        text-color="white"
                        >{{ tag }}</v-chip
                      >
                      <v-chip
                        v-else-if="i == 2"
                        :key="tag + 'desktop' + resource.id"
                        class="ma-2 titles elevation-4"
                        style="height:25px;"
                        @click="pushTag(tag)"
                        text-color="white"
                        >+&nbsp;{{ resource.tags.length - 2 }}</v-chip
                      >
                    </template>
                    <v-chip
                      v-if="
                        resource.state &&
                          ((resource.type == 'profile' &&
                            resource.stateSwitch) ||
                            resource.type == 'news')
                      "
                      :key="resource.state + 'desktop' + resource.id"
                      @click="pushTag(resource.state)"
                      class="ma-2 secondary elevation-4 titles--text"
                      style="height:25px;"
                      text-color="white"
                      >{{ resource.state }}</v-chip
                    >
                  </div>
                  <v-btn
                    color="secondary"
                    text-color="secondary"
                    v-if="resource.count != null"
                    class="upvote elevation-4"
                    flat
                    lighten-2
                    style="border-radius: 20px;  height:25px; min-width:5px; color:white;padding: 10px;    font-weight: 600; background: #014A3C !important;"
                  >
                    <v-icon dark style="font-size:20px; ">star</v-icon>
                    &nbsp; {{ resource.count }}
                  </v-btn>
                  <v-chip
                    color="secondary"
                    v-if="resource.supporters != null"
                    class="ma-2 upvote elevation-4"
                    style="background:#014A3C !important;  height:25px; padding: 5px; font-weight:600;"
                    text-color="secondary"
                    ><v-icon dark style="font-size:20px; ">person</v-icon>
                    &nbsp;{{ resource.supporters }}</v-chip
                  >
                </v-list>
                <!-- <p
                  pa-2
                  style="display: inline; font-weight: bold;padding-top: 2px;padding-left: 10px;margin-bottom: 0px; text-transform: uppercase;"
                  class="text-wrap"
                >
                  {{ resource.type }}
                </p> -->
                <p
                  pa-2
                  v-if="resource.time != null"
                  style="display: inline; font-weight: bold;padding-top: 2px;margin-bottom: 0px; text-transform: uppercase;"
                  class="text-wrap"
                >
                  {{ resource.time }}
                </p>
                <p
                  pa-2
                  v-if="resource.bio != null"
                  style="display: inline; font-weight: bold;padding-top: 2px;margin-bottom: 0px; "
                  class="text-wrap"
                >
                  {{ resource.bio.substring(0,100).trim() }}<strong v-if="resource.bio.length > 99">...</strong>
                </p>
              </v-card>
            </div>
          </template>
        </v-list>
        <v-card v-else style="text-align: center; display:inline;">
          <h1 style="padding: 50px; color:white">Nothing Matches Your Input</h1>
        </v-card>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import firebase from "firebase";
import "firebase/firestore";

export default {
  data() {
    return {
      search: "",
      datemenu: false,
      dateEndmenu: false,
      searchDate: "",
      searchEndDate: "",
      profile: false,
      News: true,
      location: "",
      possibleTags: {
        occupation: [],
        topics: [
          "Congress",
          "Environment",
          "Education",
          "Supreme Court",
          "Public Health",
          "Public Safety",
          "Military",
          "Economy",
          "International Affairs",
          "Social Justice",
          "Federal Spending",
          "Technology",
          "Entertainment",
          "Human Rights",
          "Litigation",
          "Politics",
        ],
        location: [
          "United States",
          "Alabama",
          "Alaska",
          "American Samoa",
          "Arizona",
          "Arkansas",
          "California",
          "Colorado",
          "Connecticut",
          "Delaware",
          "Washington D.C",
          "Florida",
          "Georgia",
          "Guam",
          "Hawaii",
          "Idaho",
          "Illinois",
          "Indiana",
          "International",
          "Iowa",
          "Kansas",
          "Kentucky",
          "Louisiana",
          "Maine",
          "Maryland",
          "Massachusetts",
          "Michigan",
          "Minnesota",
          "Mississippi",
          "Missouri",
          "Montana",
          "Nebraska",
          "Nevada",
          "New Hampshire",
          "New Jersey",
          "New Mexico",
          "New York",
          "North Carolina",
          "North Dakota",
          "Northern Mariana Islands",
          "Ohio",
          "Oklahoma",
          "Oregon",
          "Pennsylvania",
          "Puerto Rico",
          "Rhode Island",
          "South Carolina",
          "South Dakota",
          "Tennessee",
          "Texas",
          "U.S. Virgin Islands",
          "Utah",
          "Vermont",
          "Virginia",
          "Washington",
          "West Virginia",
          "Wisconsin",
          "Wyoming",
        ],
      },
      chosenTags: [],
      maxSelected: 2,
      resources: [],
    };
  },
  watch: {
    $route(to, from) {
      if (to !== from) {
        var self = this;
        self.search = this.$route.params.id;
        this.pullFromDatabase();
      }
    },
    search: function(val) {
      if (val == undefined) {
        this.search = "";
      }
    },
    chosenTags: function() {
      this.pullFromDatabase();
    },
    location: function() {
      this.pullFromDatabase();
    },
    searchDate: function() {
      if (
        this.searchDate == null ||
        this.searchDate == "" ||
        this.searchDate == undefined
      ) {
        this.searchEndDate = null;
      }
    },
  },
  created() {
    if (this.$route.params.tags) {
      this.chosenTags.push(this.$route.params.tags);
      this.search = " ";
    }
    if (this.$route.params.location) {
      this.location = this.$route.params.location;
      this.search = " ";
    }
    this.pullFromDatabase();
  },
  computed: {
    ...mapState(["user", "userProfile", "userNames"]),
    computedCounterValue() {
      return this.chosenTags.length;
    },
    filteredResources() {
      return this.resources
        .filter(
          (resource) =>
            (resource.title
              .toLowerCase()
              .startsWith(this.search.toLowerCase()) ||
              (resource.type == "profile" &&
                resource.title
                  .split(" ")[1]
                  .toLowerCase()
                  .startsWith(this.search.toLowerCase()))) &&
            this.tagsSearch(resource) &&
            this.locationTag(resource) &&
            ((resource.type == "profile" && this.profile) ||
              (resource.type == "news" && this.News)) &&
            ((this.searchDate != "" && this.timeCheck(resource)) ||
              this.searchDate == "" ||
              this.searchDate == undefined ||
              this.searchDate == null)
        )
        .sort((a, b) => {
          if (a.type == "news" && b.type == "news") {
            b.time - a.time;
          } else if (a.type == "news") {
            return -1;
          } else if (b.type == "news") {
            return 1;
          } else {
            return 0;
          }
        });
    },
  },
  mounted: function() {
    var self = this;
    self.search = this.$route.params.id;
    this.pullFromDatabase;
    this.possibleTags.topics = this.possibleTags.topics.sort();
  },
  methods: {
    openPost(n) {
      this.$store.dispatch("addInteract", {
        tags: n.tags,
        value: 50000,
      });

      this.$router.push("/" + n.type + "/" + n.id);
    },
    change() {
      this.$router.push("/search/" + this.search);
    },
    changeInput(e, type) {
      if (e && type == "profile") {
        this.News = false;
        this.searchDate = null;
        this.searchEndDate = null;
      } else if (!e && type == "profile") {
        this.News = true;
      } else if (e && type == "news") {
        this.profile = false;
      } else if (!e && type == "news") {
        this.profile = true;
        this.searchDate = null;
        this.searchEndDate = null;
      }
      this.pullFromDatabase();
    },
    adjustTime() {
      const date2 = new Date();
      this.resources.forEach((value) => {
        if (value.type == "news" && typeof value.time != "string") {
          value.timestamp = value.time;
          const diffTimes = date2.getTime() - value.time;
          const diffDayss = Math.floor(diffTimes / (1000 * 60 * 60 * 24));
          if (diffDayss < 1) {
            var diff = (date2.getTime() - value.time) / 1000;
            diff /= 60 * 60;
            if (diff < 1) {
              var minutes = Math.floor(diff * 60);
              if (Math.abs(Math.round(minutes)) == 1) {
                value.time = Math.abs(Math.round(minutes)) + " minute ago";
              } else {
                value.time = Math.abs(Math.round(minutes)) + " minutes ago";
              }
            } else {
              if (Math.abs(Math.round(diff)) == 1) {
                value.time = 1 + " hour ago";
              } else {
                value.time = Math.abs(Math.round(diff)) + " hours ago";
              }
            }
          } else {
            if (diffDayss == 1) {
              value.time = diffDayss + " day ago";
            } else if (diffDayss >= 7) {
              value.time = new Date(value.time).toDateString();
              value.time =
                value.time.substring(3, 10) + "," + value.time.substring(10);
            } else {
              value.time = diffDayss + " days ago";
            }
          }
        }
      });

      this.resources.sort(function(a, b) {
        if (a.type == "news" && b.type == "news") {
          return b.timestamp - a.timestamp;
        } else if (a.type == "news" && b.type != "news") {
          return b - a;
        } else if (a.type != "news" && b.type == "news") {
          return a - b;
        } else {
          return a - b;
        }
      });
    },
    timeCheck(resource) {
      const date = new Date(`${this.searchDate}`);
      var utcSeconds = resource.timestamp / 1000;
      var d = new Date(0);
      d.setUTCSeconds(utcSeconds);
      d.setHours(0, 0, 5, 5);
      date.setHours(24, 0, 0, 0);
      if (this.searchEndDate) {
        const enddate = new Date(`${this.searchEndDate}`);
        enddate.setHours(47, 59, 59, 0);

        return date.getTime() < d.getTime() && enddate.getTime() > d.getTime();
      }

      return date.getTime() < d.getTime();
    },
    tagsSearch(resource) {
      var bool = true;
      if (
        this.chosenTags == [] ||
        this.chosenTags == "" ||
        this.chosenTags == undefined ||
        this.chosenTags == null
      ) {
        bool = true;
      } else {
        this.chosenTags.forEach((val) => {
          if (!resource.tags.includes(val)) {
            bool = false;
          }
        });
      }
      return bool;
    },
    locationTag(resource) {
      if (
        this.location == "" ||
        this.location == undefined ||
        this.location == null ||
        this.location == "United States"
      ) {
        return true;
      } else {
        if (
          resource.type == "profile" &&
          resource.stateSwitch &&
          resource.state == this.location
        ) {
          return true;
        }
        if (resource.state == this.location) {
          return true;
        }
      }
      return false;
    },
    Cancel() {
      this.$router.push("/news");
    },
    async pullFromDatabase() {
      if (
        this.search != undefined &&
        this.search != null &&
        this.search != " "
      ) {
        if (this.profile) {
          const snapshot = await firebase
            .firestore()
            .collection("users")
            .where("name", ">=", this.search.toLowerCase())
            .where("name", "<=", this.search.toLowerCase() + "~")
            .get();

          const snapshot2 = await firebase
            .firestore()
            .collection("users")
            .where("username", ">=", this.search.toLowerCase())
            .where("username", "<=", this.search.toLowerCase() + "~")
            .get();

          snapshot.forEach((doc) => {
            var bool = true;
            this.resources.forEach((val) => {
              if (val.id == doc.id) {
                bool = false;
              }
            });
            if (bool && doc.data().profile) {
              var tag = doc.data().tags;
              this.resources.push({
                type: "profile",
                stateSwitch: doc.data().stateSwitch,
                bio: doc.data().bio,
                id: doc.id,
                title: doc.data().name,
                tags: tag,
                username: doc.data().username,
                state: doc.data().state,
                count: null,
                time: null,
                supporters: doc.data().supporter_ids.length,
              });
            }
          });

          snapshot2.forEach((doc) => {
            var bool = true;
            this.resources.forEach((val) => {
              if (val.id == doc.id) {
                bool = false;
              }
            });
            if (bool && doc.data().profile) {
              var t = doc.data().tags;
              this.resources.push({
                type: "profile",
                id: doc.id,
                stateSwitch: doc.data().stateSwitch,
                title: doc.data().name,
                tags: t,
                state: doc.data().state,
                bio: doc.data().bio,
                username: doc.data().username,
                count: null,
                time: null,
                supporters: doc.data().supporter_ids.length,
              });
            }
          });
        }

        if (this.News) {
          const snap = await firebase
            .firestore()
            .collection("concordposts")
            .where("title", ">=", this.search.toLowerCase())
            .where("title", "<=", this.search.toLowerCase() + "~")
            .get();

          snap.forEach((doc) => {
            var bool = true;
            this.resources.forEach((val) => {
              if (val.id == doc.id) {
                bool = false;
              }
            });
            if (bool) {
              this.resources.push({
                type: "news",
                id: doc.id,
                name: doc.data().name,
                title: doc.data().title,
                state: doc.data().tags.pop(),
                tags: doc.data().tags.slice(0, doc.data().tags.length - 1),
                username: null,
                count: doc.data().count,
                time: doc.data().time,
                supporters: null,
              });
              this.adjustTime();
            }
          });
        }
      } else {
        if (this.chosenTags.length >= 1) {
          if (this.News) {
            const snap3 = await firebase
              .firestore()
              .collection("concordposts")
              .where("tags", "array-contains", this.chosenTags[0])
              .get();
            if (this.chosenTags.length == 2) {
              const snapshot4 = await firebase
                .firestore()
                .collection("concordposts")
                .where("tags", "array-contains", this.chosenTags[1])
                .get();
              snapshot4.forEach((doc) => {
                snap3.forEach((doc2) => {
                  if (doc2.id == doc.id) {
                    var bool = true;
                    this.resources.forEach((val) => {
                      if (val.id == doc.id) {
                        bool = false;
                      }
                    });
                    if (bool) {
                      this.resources.push({
                        type: "news",
                        id: doc.id,
                        name: doc.data().name,
                        title: doc.data().title,
                        state: doc.data().tags.pop(),
                        tags: doc
                          .data()
                          .tags.slice(0, doc.data().tags.length - 1),
                        username: null,
                        count: doc.data().count,
                        time: doc.data().time,
                        supporters: null,
                      });
                      this.adjustTime();
                    }
                  }
                });
              });
            } else {
              snap3.forEach((doc) => {
                var bool = true;
                this.resources.forEach((val) => {
                  if (val.id == doc.id) {
                    bool = false;
                  }
                });
                if (bool) {
                  this.resources.push({
                    type: "news",
                    id: doc.id,
                    title: doc.data().title,
                    name: doc.data().name,
                    state: doc.data().tags.pop(),
                    tags: doc.data().tags.slice(0, doc.data().tags.length - 1),
                    username: null,
                    count: doc.data().count,
                    time: doc.data().time,
                    supporters: null,
                  });
                  this.adjustTime();
                }
              });
            }
          }

          if (this.profile) {
            const snapshot = await firebase
              .firestore()
              .collection("users")
              .where("tags", "array-contains", this.chosenTags[0])
              .get();
            if (this.chosenTags.length == 2) {
              const snapshot2 = await firebase
                .firestore()
                .collection("users")
                .where("tags", "array-contains", this.chosenTags[1])
                .get();
              snapshot2.forEach((doc) => {
                snapshot.forEach((doc2) => {
                  if (doc2.id == doc.id) {
                    var bool = true;
                    this.resources.forEach((val) => {
                      if (val.id == doc.id) {
                        bool = false;
                      }
                    });
                    if (bool && doc.data().profile) {
                      var tag = doc.data().tags;
                      this.resources.push({
                        type: "profile",
                        id: doc.id,
                        title: doc.data().name,
                        stateSwitch: doc.data().stateSwitch,
                        tags: tag,
                        bio: doc.data().bio,
                        state: doc.data().state,
                        username: doc.data().username,
                        count: null,
                        time: null,
                        supporters: doc.data().supporter_ids.length,
                      });
                    }
                  }
                });
              });
            } else {
              snapshot.forEach((doc) => {
                var bool = true;
                this.resources.forEach((val) => {
                  if (val.id == doc.id) {
                    bool = false;
                  }
                });
                if (bool && doc.data().profile) {
                  var tag = doc.data().tags;
                  this.resources.push({
                    type: "profile",
                    id: doc.id,
                    title: doc.data().name,
                    stateSwitch: doc.data().stateSwitch,
                    tags: tag,
                    bio: doc.data().bio,
                    state: doc.data().state,
                    username: doc.data().username,
                    count: null,
                    time: null,
                    supporters: doc.data().supporter_ids.length,
                  });
                }
              });
            }
          }
        }

        if (this.location == "United States of America") {
          if (this.News) {
            const snap3 = await firebase
              .firestore()
              .collection("concordposts")
              .get();
            snap3.forEach((doc) => {
              var bool = true;
              this.resources.forEach((val) => {
                if (val.id == doc.id) {
                  bool = false;
                }
              });
              if (bool) {
                this.resources.push({
                  type: "news",
                  id: doc.id,
                  title: doc.data().title,
                  name: doc.data().name,
                  state: doc.data().tags.pop(),
                  tags: doc.data().tags.slice(0, doc.data().tags.length - 1),
                  username: null,
                  count: doc.data().count,
                  time: doc.data().time,
                  supporters: null,
                });
                this.adjustTime();
              }
            });
          }

          if (this.profile) {
            const snapshot2 = await firebase
              .firestore()
              .collection("users")
              .get();

            snapshot2.forEach((doc) => {
              var bool = true;
              this.resources.forEach((val) => {
                if (val.id == doc.id) {
                  bool = false;
                }
              });

              if (bool && doc.data().profile) {
                var tag = doc.data().tags;
                this.resources.push({
                  type: "profile",
                  id: doc.id,
                  title: doc.data().name,
                  stateSwitch: doc.data().stateSwitch,
                  state: doc.data().state,
                  bio: doc.data().bio,
                  tags: tag,
                  username: doc.data().username,
                  count: null,
                  time: null,
                  supporters: doc.data().supporter_ids.length,
                });
              }
            });
          }
        } else if (
          this.location != "" &&
          this.location != undefined &&
          this.location != null
        ) {
          if (this.News) {
            const snap3 = await firebase
              .firestore()
              .collection("concordposts")
              .where("tags", "array-contains", this.location)
              .get();

            snap3.forEach((doc) => {
              var bool = true;
              this.resources.forEach((val) => {
                if (val.id == doc.id) {
                  bool = false;
                }
              });
              if (bool) {
                this.resources.push({
                  type: "news",
                  id: doc.id,
                  title: doc.data().title,
                  name: doc.data().name,
                  state: doc.data().tags.pop(),
                  tags: doc.data().tags.slice(0, doc.data().tags.length - 1),
                  username: null,
                  count: doc.data().count,
                  time: doc.data().time,
                  supporters: null,
                });
                this.adjustTime();
              }
            });
          }

          if (this.profile) {
            const snapshot = await firebase
              .firestore()
              .collection("users")
              .where("state", "==", this.location)
              .where("stateSwitch", "!=", false)
              .get();

            snapshot.forEach((doc) => {
              var bool = true;
              this.resources.forEach((val) => {
                if (val.id == doc.id) {
                  bool = false;
                }
              });
              if (bool && doc.data().profile) {
                var tag = doc.data().tags;
                this.resources.push({
                  type: "profile",
                  id: doc.data().uid,
                  title: doc.data().name,
                  stateSwitch: doc.data().stateSwitch,
                  state: doc.data().state,
                  bio: doc.data().bio,
                  tags: tag,
                  username: doc.data().username,
                  count: null,
                  time: null,
                  supporters: doc.data().supporter_ids.length,
                });
              }
            });
          }
        }
      }
    },
  },
};
</script>
